import { Switch } from '@headlessui/react'
import type { Switch as SwitchProps } from '@headlessui/react'
import React from 'react'
import { classNames } from 'utils/dom-helpers'
export interface ICustomSwitch {
    value: boolean
    onChangeValue: (val: boolean) => void
    label?: string | React.ReactNode | JSX.Element
    labelStyles?: React.CSSProperties
    disable?: boolean
    className?: string
}
const CustomSwitch: React.FC<ICustomSwitch> = ({
    value,
    onChangeValue,
    label = '',
    labelStyles = {},
    disable = false,
    className = ''
}) => {
    return (
        <div className={classNames("flex items-center",
            className
        )}>
            <Switch
                disabled={disable}
                checked={value}
                onChange={(e) => onChangeValue(e)}
                className={classNames(
                    `${value
                        ? 'bg-[#4b95b7]'
                        : 'bg-primary bg-opacity-30'}
                block relative inline-flex mt-2 flex-shrink-0 h-5 w-10 border-2 border-transparent rounded-full  transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`,
                    disable ? 'cursor-not-allowed' : 'cursor-pointer'
                )}
            >
                <span
                    aria-hidden="true"
                    className={`${value ? 'translate-x-5' : 'translate-x-0'}
        pointer-events-none inline-block h-4 w-4 rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200`}
                />
            </Switch>
            <span className="pt-2 ml-2" style={{ ...labelStyles }}>
                {label}
            </span>
        </div>
    )
}

export default CustomSwitch
